import Asyncview from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import ProductMasonry from './ProductMasonry';
import VariantHelper from '../helpers/VariantHelper';
import ImageZoom from './ImageZoom';
import ProductGallery from './ProductGallery';
import RTE from './RTE';
import Select from './Select';
import themeUtils from '../themeUtils';

export default class Product {
  constructor(el, options) {
    this.setupProductDetails = this.setupProductDetails.bind(this);
    this.positionProductInfo = this.positionProductInfo.bind(this);
    this.el = el;
    this.$el = $(el);

    // Set up conditional options
    this.product = options.product;
    this.productSettings = options.product_settings;
    this.labels = JSON.parse($('[data-product-success-labels]').html());
    this.imagesLayout = options.images_layout;
    this.isQuickshop = options.isQuickshop;
    this.enableZoom = options.enable_zoom;
    this.enableVideoAutoplay = options.enable_video_autoplay;
    this.enableVideoLooping = options.enable_video_looping;
    this.enableCartRedirection = options.enable_cart_redirection;
    this.enableFixedPositioning = options.enable_fixed_positioning;

    this.window = $(window);
    this.variantHelpers = null;
    this.productMasonryLayout = null;
    this.rteViews = [];
    this.selectViews = [];

    this.$productForm = $('[data-product-form]', this.$el);
    this.$productContainer = $('.product', this.$el);
    this.productMainImage = $('.product-gallery--viewport', this.$el);
    this.productImages = $('.product-images', this.$el);
    this.$productThumbnails = $('.product-thumbnails img', this.$el);
    this.productThumbnail = $('.product-thumbnail', this.$el);
    this.productDetailsWrapper = $('.product-details-wrapper', this.$el);
    this.productDetails = $('.product-details', this.$el);
    this.productMessages = $('.product-message', this.$el);
    this.$addToCart = $('.add-to-cart', this.$el);
    this.images = JSON.parse($('[data-images]', this.$el).text());
    this.smallGallery = themeUtils.isSmall();
    this.productGallery = null;

    this._initProductGallery();

    this.reloadGallery = this._reloadGallery.bind(this);

    this.window.on('resize.product-gallery', () => this.reloadGallery);


    $('.rte', this.$el).each((index, rte) => {
      this.rteViews.push(new RTE({ el: rte }));
    });

    $('select', this.$el).each((index, select) => {
      if (!select.hasAttribute('data-select-ignore')) {
        this.selectViews.push(new Select({ el: select }));
      }
    });

    this.setupVariants();

    if (this.enableFixedPositioning) {
      this.positionProductInfo();
    }

    this.$addToCart.on('click', event => this.addToCart(event));

    if (Theme.enable_currency_converter) {
      $('[data-currency-converter]').trigger('updateCurrency');
    }

    if (Shopify.PaymentButton != null) {
      Shopify.PaymentButton.init();
    }

    if (this.imagesLayout === 'list') {
      this.window.on(
        'load.product-images-list, resize.product-images-list',
        themeUtils.debounce(this.setupProductDetails, 100),
      );
    }
  }

  _initProductGallery() {
    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        product_container: this.$productContainer[0],
        images_layout: this.imagesLayout,
        images_json: this.images,
        enable_zoom: this.enableZoom,
        enable_video_looping: this.enableVideoLooping,
        enable_video_autoplay: this.enableVideoAutoplay,
        isQuickshop: this.isQuickshop
      }
    );
  }

  _reloadGallery() {
    if (themeUtils.isSmall() && !this.smallGallery) {
      this.productGallery.unload();
      this.productGallery = null;
      this._initProductGallery();
      this.smallGallery = true;
    }

    if (!themeUtils.isSmall() && this.smallGallery) {
      this.productGallery.unload();
      this.productGallery = null;
      this._initProductGallery();
      this.smallGallery = false;
    }
  }

  unload() {
    clearTimeout(this.positionTimeout);

    if (this.variantHelpers != null) {
      this.variantHelpers.unload();
    }
    if (this.productGallery) {
      this.productGallery.unload();
    }

    if (this.rteViews.length > 0) {
      this.rteViews = [];
    }

    if (this.selectViews.length > 0) {
      this.selectViews = [];
    }
    this.window.off('.product-images-list');
    this.window.off('.product-gallery');
  }

  setupVariants() {
    // Form selectors
    this.$addToCartButton = this.$el.find('.add-to-cart');
    this.$priceArea = this.$el.find('.product-price');

    // Setup product information
    this.$variantDropdowns = this.$el.find('[data-option-select]');

    this.variantHelpers = new VariantHelper({
      $selector: this.$variantDropdowns,
      type: 'select',
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      productSettings: this.productSettings,
      productJSON: this.product,
      productGallery: this.productGallery,
    });

    return this.$variantDropdowns.trigger('change');
  }

  setupProductDetails() {
    if (this.imagesLayout !== 'list') { return; }

    this.productDetails.width(this.productDetailsWrapper.width());
  }

  positionProductInfo() {
    const detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
    let viewportHeight = window.innerHeight;

    if (document.documentElement.clientHeight < window.innerHeight) {
      viewportHeight = document.documentElement.clientHeight;
    }

    if (
      (window.innerWidth > 770)
      && (viewportHeight > detailsHeight)
    ) {
      this.triggerFixedProductInfo();
    } else {
      this.productDetails
        .removeClass('product-details-fixed')
        .removeClass('product-details-absolute');
    }

    return requestAnimationFrame(this.positionProductInfo);
  }

  triggerFixedProductInfo() {
    if (this.imagesLayout !== 'list') { return; }

    const scrollTop = this.window.scrollTop();
    const imagesHeight = this.productImages.get(0).getBoundingClientRect().height;
    const imagesOffsetTop = this.productImages.offset().top;
    const imagesOffsetBottom = imagesOffsetTop + imagesHeight;
    const detailsWrapperOffset = this.productDetailsWrapper.offset().top;
    let detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
    let detailsOffsetTop = this.productDetails.offset().top;
    let detailsOffsetBottom = detailsOffsetTop + detailsHeight;

    if (this.productDetails.get(0).getBoundingClientRect().height < imagesHeight) {
      // If we're far enough down the page that the content is near the window top
      if ((detailsWrapperOffset - scrollTop) < 0) {
        // Check if our details / images are out of line but low enough to "fix"
        if ((detailsOffsetBottom < imagesOffsetBottom) || (scrollTop < detailsOffsetTop)) {
          this.productDetails
            .removeClass('product-details-absolute')
            .addClass('product-details-fixed');
        }

        detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
        detailsOffsetTop = this.productDetails.offset().top;
        detailsOffsetBottom = detailsOffsetTop + detailsHeight;

        // If we're far enough down then this positions items near the bottom
        if ((detailsOffsetBottom >= imagesOffsetBottom) || (scrollTop >= detailsOffsetTop)) {
          this.productDetails
            .removeClass('product-details-fixed')
            .addClass('product-details-absolute');
        }
      } else {
        this.productDetails
          .removeClass('product-details-fixed')
          .removeClass('product-details-absolute');
      }
    }
  }

  addToCart(e) {
    if (this.enableCartRedirection) {
      return;
    }

    e.preventDefault();

    this.productMessages.html('');

    $.post(
      '/cart/add.js',
      this.$productForm.serialize(),
      null,
      'json',
    ).done((item) => {
      const message = Theme.addToCartSuccess
        .replace('**product**', item.title)
        .replace('**cart_link**', `<a href="/cart">${this.labels.cartLink}</a>`)
        .replace('**continue_link**', `<a href="/collections/all">${this.labels.continueLink}</a>`)
        .replace('**checkout_link**', `<a href="/checkout">${this.labels.checkoutLink}</a>`);

      return setTimeout(() => {
        this.productMessages
          .html(message)
          .addClass('success-message')
          .removeClass('error-message');
        return this.updateCart(item);
      },
        500);
    }).fail(error => this.handleErrors(error));
  }

  updateCart(newItem) {
    $('.mini-cart').removeClass('empty');
    const miniCartItemWrapper = document.querySelector('.mini-cart-item-wrapper');
    const cartCount = $('.cart-count-number');
    const labels = this.labels;

    Asyncview.load(
      '/cart',
      '_mini-ajax',
    )
      .done(({ options, html }) => {
        const updatedMiniCart = document.createElement('div');
        updatedMiniCart.innerHTML = html.miniCart;
        cartCount.text(options.itemCount);

        morphdom(
          miniCartItemWrapper,
          updatedMiniCart.querySelector('.mini-cart-item-wrapper'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );
      });

    miniCartItemWrapper.querySelectorAll('.money').forEach(money => CurrencyConverter.update(money));
    rimg.watch(miniCartItemWrapper);
  }

  handleErrors(error) {
    return setTimeout(() => this.$el.find('.product-message')
      .html(error.responseJSON.description)
      .addClass('error-message')
      .removeClass('success-message'),
      1000);
  }
}
